// extracted by mini-css-extract-plugin
module.exports = {"left_nav":"Styles_left_nav__iBgL3","hover_green":"Styles_hover_green__3_iM9","collection-item":"Styles_collection-item__181cp"};